// extracted by mini-css-extract-plugin
module.exports = {"link":"Tutorial_link__Ek8QU","tutorialContainer":"Tutorial_tutorialContainer__3ZX27"};